import ExpensesItem from "./ExpensesItem";

export default ExpensesItem;
